import { render, staticRenderFns } from "./select-municipio.vue?vue&type=template&id=c6025c1a&"
import script from "./select-municipio.vue?vue&type=script&lang=js&"
export * from "./select-municipio.vue?vue&type=script&lang=js&"
import style0 from "./select-municipio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports